import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";

export const searchGraphUsers = (searchTerm) => {
  return base.post({
    url: API_PARAM.GRAPH_USER,
    data: { searchTerm },
  });
};

export const searchGraphUserPhoto = (username) => {
  return base.post({
    url: API_PARAM.GRAPH_USER_PHOTO,
    data: { username },
  });
};

export const searchGraphCurrentUserPhoto = () => {
  return base.get({
    url: API_PARAM.GRAPH_CURRENT_USER_PHOTO,
  });
};
